import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface WindowState {
  isMobile: boolean;
  windowWidth: number;
}

const breakPoint = Number(import.meta.env.VITE_MOBILE_BREAKPOINT) || 768;

const initialState: WindowState = {
  isMobile:
    typeof window !== 'undefined' ? window.innerWidth <= breakPoint : false,
  windowWidth: typeof window !== 'undefined' ? window.innerWidth : 0,
};

export const windowSlice = createSlice({
  name: 'window',
  initialState,
  reducers: {
    updateWindow: (state, action: PayloadAction<number>) => {
      return {
        ...state,
        windowWidth: action.payload,
        isMobile: action.payload <= breakPoint,
      };
    },
  },
});

export const { updateWindow } = windowSlice.actions;
export default windowSlice.reducer;
